export enum TransformActivityTabId {
    WEIGHT= 'weight-button',
    ACTIVITY = 'activity-button',
    LESSON = 'lesson-button',
    FOOD = 'food-button',
    COACHING = 'coaching-button',
    BLOOD_PRESSURE = 'blood-pressure-button'
}
